import { useRef } from 'react';

import { Button, ButtonProps, SxProps, Theme } from '@mui/material';

type UploadFileInputProps = {
  sx?: SxProps<Theme>;
  label?: string;
  accept: string;
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  disabled?: boolean;
  startIcon?: React.ReactNode;
  children?: React.ReactNode;
  fullWidth?: boolean;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const UploadFileInput: React.FunctionComponent<UploadFileInputProps> = ({
  sx,
  label,
  accept,
  variant = 'contained',
  color = 'primary',
  startIcon,
  disabled,
  children,
  fullWidth,
  onFileUpload,
}) => {
  const fileInputRef = useRef(null);

  return (
    <>
      <Button
        sx={sx}
        fullWidth={fullWidth}
        variant={variant}
        color={color}
        disabled={disabled}
        onClick={() => fileInputRef.current.click()}
        startIcon={startIcon}
        size='small'
      >
        {label} {children}
      </Button>
      <input disabled={disabled} ref={fileInputRef} type='file' hidden accept={accept} onChange={onFileUpload} />
    </>
  );
};
